<template>
    <div>
        <div
            v-if="!consentSet"
            class="cookie-banner"
        >
            <p>
                Vi använder cookies för att anpassa innehåll och analysera trafik.
                <button
                    class="btn btn-link p-0"
                    @click="showModal = true"
                >
                    Läs mer
                </button>
            </p>
            <div class="buttons">
                <button @click="acceptAll">
                    Acceptera alla
                </button>
                <button @click="rejectAll">
                    Avböj icke nödvändiga
                </button>
            </div>
        </div>
        <modal
            v-model="showModal"
            :backdrop="false"
            class="modal"
        >
            <template #modal-header>
                <div
                    class="modal-header"
                >
                    <p><i>Smoothcomp AB driftar denna hemsida på uppdrag av <br> Svenska Kennelklubben.</i></p>
                    <h2>Vi samlar in information om dig på olika sätt</h2>
                </div>
            </template>

            <template #modal-body>
                <div
                    class="modal-body"
                >
                    <p>
                        <strong>Allmän information</strong><br>
                        Smoothcomp AB samlar in information om ditt användande av webbplatsen. Denna information
                        kan komma att delas med andra intressenter.
                        Smoothcomp AB följer GDPR och du kan redigera, dölja och radera information om ditt användande.
                    </p>
                    <p>
                        <strong>Cookies.</strong><br>
                        Som många andra online-applikationer så använder vi oss av spårningsverktyg och så kallade
                        "cookies". Detta är små textfiler vår internetsida placerar i din dator.
                        Du kan läsa mer om cookies,
                        och hur du avaktiverar dem i hjälpavdelningen på din dator.
                    </p>

                    <p>
                        <strong>Direkt från dig.</strong><br>
                        Detta sker exempelvis genom att du accepterar ett erbjudande, anmäler dig
                        till ett arrangemang, laddar ner en app, gör en kommentar på vår webbsida, ställer en fråga,
                        skriver ett email, kontaktar Smoothcomps kundservice eller på annat sätt tar del av våra tjänster.
                    </p>

                    <p>
                        <strong>Genom att använda vår webbsida och appar.</strong><br>
                        Du kan nå våra webbsidor och appar från en dator, en telefon,
                        så kallade surfplattor eller andra enheter. Vi använder oss av spårningsverktyg
                        såsom internet cookies och spårpixlar på våra webbsidor och appar för att samla in
                        information kring ditt användande.
                    </p>

                    <p>
                        <strong>Från en tredje part.</strong><br>
                        Om du till exempel väljer att använda en social media som är integrerad med våra
                        webbsidor eller appar så räknas
                        denna sociala media som en tredje part och den delar information om dig med oss.
                        Denna information kan innehålla
                        ditt namn och emailadress. Din aktivitet på våra hemsidor och appar
                        kan komma att delas på denna sociala media-plattform.
                    </p>
                </div>
            </template>

            <template #modal-footer>
                <div
                    class="modal-footer"
                >
                    <button
                        class="btn btn-primary"
                        @click="showModal = false"
                    >
                        Stäng
                    </button>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
import modal from 'vue@/components/modal.vue';

export default {
    name: 'CookieConsent',
    components: {
        modal,
    },
    data() {
        return {
            preferences: {
                necessary: true,
                analytics: false,
                marketing: false
            },
            consentSet: false,
            showModal: false,
        };
    },
    mounted() {
        const storedPrefs = localStorage.getItem('cookieConsent');
        if (storedPrefs) {
            this.preferences = JSON.parse(storedPrefs);
            this.consentSet = true;
            this.loadScripts(this.preferences);
        }
    },
    methods: {
        acceptAll() {
            this.preferences = {
                necessary: true,
                analytics: true,
                marketing: true
            };
            this.storeConsent();
        },
        rejectAll() {
            this.preferences = {
                necessary: true,
                analytics: false,
                marketing: false
            };
            this.storeConsent();
        },
        savePreferences() {
            this.storeConsent();
            this.showCustomize = false;
        },
        storeConsent() {
            localStorage.setItem('cookieConsent', JSON.stringify(this.preferences));
            this.consentSet = true;
            this.loadScripts(this.preferences);
        },
        loadScripts(prefs) {
            const allowed = [];
            if (prefs.analytics) allowed.push('analytics');
            if (prefs.marketing) allowed.push('marketing');

            const scripts = document.querySelectorAll('script[type="text/plain"]');
            scripts.forEach((script) => {
                const category = script.getAttribute('data-category');
                if (allowed.includes(category)) {
                    const newScript = document.createElement('script');
                    const src = script.getAttribute('data-src');

                    if (src) {
                        newScript.src = src;
                    } else {
                        newScript.text = script.textContent;
                    }
                    document.body.appendChild(newScript);
                }
            });
        }
    }
};
</script>

<style scoped>
.cookie-banner {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #333;
    color: white;
    padding: 15px;
    text-align: center;
    z-index: 100;
}

.cookie-banner .buttons button {
    margin: 0 5px;
    padding: 8px 16px;
    border: none;
    background: #4CAF50;
    color: white;
    cursor: pointer;
}

.cookie-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    color: black;
    padding: 20px;
    z-index: 10000;
    border-radius: 8px;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
}

.modal-backdrop {
  z-index: 1050 !important;
}

.modal {
  z-index: 1100 !important;
}
</style>
